import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';
import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';
import type { YYYYMMDD } from '@/features/transaction';

export const transactionRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/transaction',
  component: lazyRouteComponent(() => import('@/pages/transaction')),
  validateSearch: (
    search: Partial<FilterDrawerFormValue & { start_at: YYYYMMDD; end_at: YYYYMMDD }>,
  ) => {
    return {
      ...search,
      // start_at: search.start_at as YYYYMMDD,
      // end_at: search.end_at as YYYYMMDD,
    };
  },
});

export const transactionDetailRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/transaction/$id',
  component: lazyRouteComponent(() => import('@/pages/transaction/detail')),
});
